// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1_hfC","cls2":"SuggestedUserCard-cls2_cAS SuggestedUserCard-cls1_hfC"};